//inspiration taken from https://loading.io/spinner/pulse/-facebook-bar-pulse
const boxSize = 100;
const barWidth = 4;
const barHeight = 50;
//SVG
const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
svg.setAttribute('viewBox', `0 0 ${boxSize} ${boxSize}`);
svg.setAttribute('preserveAspectRatio', 'xMidYMid');
//Animations + Shapes
const shapes = [
    document.createElementNS("http://www.w3.org/2000/svg", "rect"),
    document.createElementNS("http://www.w3.org/2000/svg", "rect"),
    document.createElementNS("http://www.w3.org/2000/svg", "rect"),
];
shapes.forEach(shape => {
    shape.setAttribute('fill', '#888');
    shape.setAttribute('height', `${barHeight}`);
    shape.setAttribute('width', `${barWidth}`);
});
shapes.forEach((shape, index) => {
    const animateY = document.createElementNS("http://www.w3.org/2000/svg", "animate");
    animateY.setAttribute('attributeName', 'y');
    animateY.setAttribute('keySplines', '0 0.5 0.5 1;0 0.5 0.5 1');
    animateY.setAttribute('repeatCount', 'indefinite');
    animateY.setAttribute('dur', '1s');
    animateY.setAttribute('calcMode', 'spline');
    animateY.setAttribute('keyTimes', '0;0.5;1');
    const animateHeight = document.createElementNS("http://www.w3.org/2000/svg", "animate");
    animateHeight.setAttribute('attributeName', 'height');
    animateHeight.setAttribute('keySplines', '0 0.5 0.5 1;0 0.5 0.5 1');
    animateHeight.setAttribute('repeatCount', 'indefinite');
    animateHeight.setAttribute('dur', '1s');
    animateHeight.setAttribute('calcMode', 'spline');
    animateHeight.setAttribute('keyTimes', '0;0.5;1');
    //specific values
    const x = ((boxSize / (shapes.length + 1)) - (barWidth / 2)) * (index + 1);
    const y = (boxSize - barHeight) / 2;
    shape.setAttribute('x', `${x}`);
    shape.setAttribute('y', `${y}`);
    animateY.setAttribute('begin', `${((index + 1) - shapes.length) / 10}s`);
    animateHeight.setAttribute('begin', `${((index + 1) - shapes.length) / 10}s`);
    animateY.setAttribute('values', `${y / 2};${y};${y}`);
    animateHeight.setAttribute('values', `${barHeight + y};${barHeight};${barHeight}`);
    shape.appendChild(animateY);
    shape.appendChild(animateHeight);
});
shapes.forEach(child => svg.appendChild(child));
//SVG Container
const svgContainer = document.createElement('div');
svgContainer.setAttribute('style', 'display: inline-block; width: 2em; vertical-align: middle;');
svgContainer.appendChild(svg);
//"Processing Text"
const processingTxt = document.createElement('span');
processingTxt.appendChild(document.createTextNode('Processing ...'));
export const progress = document.createElement('div');
progress.setAttribute('style', 'z-index: 1; margin: auto; text-align: center;');
progress.appendChild(svgContainer);
progress.appendChild(processingTxt);
//# sourceMappingURL=display.progress.js.map